import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState,
} from '../../utils/redux';

export const consts = createReqConsts('circles', 'removeAssignedProvider', [
  'START_SAGA',
  'STOP_SAGA',
]);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'delete',
  slug: [
    {
      type: 'payload',
      queryParameter: 'user_id',
      selector: ['userId'],
    },
    'assigned_providers',
    {
      type: 'payload',
      queryParameter: 'provider_profile_id',
      selector: ['providerId'],
    },
  ],
});

const reqReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { type } = action;
  const defaultState = reqReducer(state, action);

  switch (type) {
    case consts.SEND:
      return {
        ...defaultState,
        removedContextUserId: action.payload.userId,
      };
    default:
      return defaultState;
  }
};



// WEBPACK FOOTER //
// ./src/redux/circles/removeAssignedProvider.js